import { Injectable, signal } from '@angular/core';


/**
 * Configuration model for toast component.
 */
export class ToastConfig {
	className?: string;
	delay?: number;
}


/**
 * This service handlse toast components.
 */
@Injectable({ providedIn: 'root' })
export class ToastService {

	toasts = signal<any[]>([]);

	/**
	 * Show a generic toast.
	 */
	show(message: string, options: ToastConfig): void {
		this.toasts.update(_ => { return [..._, { message, ...options }] });
	}

	/**
	 * Show a success toast with input message.
	 */
	showSuccess(message: string, options: { delay?: number } = {}): void {
		this.show(message, Object.assign(options, { className: 'bg-success' }));
	}

	/**
	 * Show an error toast with input message.
	 */
	showError(message: string, options: { delay?: number } = {}): void {
		this.show(message, Object.assign(options, { className: 'bg-danger' }));
	}

	/**
	 * Show a warning toast with input message.
	 */
	showWarning(message: string, options: { delay?: number } = {}): void {
		this.show(message, Object.assign(options, { className: 'bg-warning' }));
	}

	/**
	 * Remove toast.
	 */
	remove(toast: any): void {
		this.toasts.update(_ => _.filter(t => t != toast));
	}
}
